import { atom } from "recoil";

export const defaultLanguage = atom({
  key: "en",
  default: {
    label: "English",
    icon: "/assets/languagesicons/english.svg",
  },
});

export const userSmartAccount = atom({
  key: "smartAccount",
  default: "",
});

export const userSmartAccountClient = atom({
  key: "smartAccountClient",
  default: null,
});

export const useSmartSession = atom({
  key: "smartSeission",
  default: null,
});
export const usePermisions = atom({
  key: "permission",
  default: null,
});
export const useEthInternalBalace = atom({
  key: "ethInteBlance",
  default: null,
});

export const usePublicClient = atom({
  key: "publicClients",
  default: null,
});

export const userProfileState = atom({
  key: "userProfile", // Must be unique
  default: {
    name: "Guest",
    profilePic: "",
  },
});

export const userPrivateKey = atom({
  key: "privateKey",
  default: null,
});
